const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const DuplicateCycleDetail = () => import(/* webpackChunkName: "duplicate" */ './cycle/view/detail.vue');
const DuplicateCycleList = () => import(/* webpackChunkName: "duplicate" */ './cycle/view/index.vue');
const DuplicateCycleDeck = () => import(/* webpackChunkName: "duplicate" */ './cycle/item/view/deck.vue');
const DuplicateCycleRank = () => import(/* webpackChunkName: "duplicate" */ './cycle/item/view/rank.vue');
const DuplicateItemAdd = () => import(/* webpackChunkName: "duplicate" */ './item/view/add.vue');
const DuplicateItemDetail = () => import(/* webpackChunkName: "duplicate" */ './item/view/detail.vue');
const DuplicateItemEdit = () => import(/* webpackChunkName: "duplicate" */ './item/view/edit.vue');
const DuplicateItemList = () => import(/* webpackChunkName: "duplicate" */ './item/view/index.vue');
const DuplicateItemTranslate = () => import(/* webpackChunkName: "duplicate" */ './item/view/translate.vue');
const DuplicateSetting = () => import(/* webpackChunkName: "duplicate" */ './setting/view/edit.vue');

export const ROUTE_NAME_DUPLICATE = {
    CYCLE: {
        INDEX: 'DuplicateCycleList',
        DETAIL: 'DuplicateCycleDetail',
        DECK: 'DuplicateCycleDeck',
        RANK: 'DuplicateCycleRank'
    },
    ITEM: {
        INDEX: 'DuplicateItemList',
        ADD: 'DuplicateItemAdd',
        EDIT: 'DuplicateItemEdit',
        DETAIL: 'DuplicateItemDetail',
        TRANSLATE: 'DuplicateItemTranslate'
    },
    SETTING: 'DuplicateSetting'
};

export default [
    {
        path: '/app/:appId/duplicate/',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'setting',
                name: ROUTE_NAME_DUPLICATE.SETTING,
                component: DuplicateSetting,
                meta: { requiresAuth: true }
            },
            {
                path: 'item',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_DUPLICATE.ITEM.INDEX,
                        component: DuplicateItemList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_DUPLICATE.ITEM.ADD,
                        component: DuplicateItemAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_DUPLICATE.ITEM.EDIT,
                        component: DuplicateItemEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_DUPLICATE.ITEM.DETAIL,
                        component: DuplicateItemDetail,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/translate',
                        name: ROUTE_NAME_DUPLICATE.ITEM.TRANSLATE,
                        component: DuplicateItemTranslate,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'cycle',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_DUPLICATE.CYCLE.INDEX,
                        component: DuplicateCycleList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':cycleId/detail',
                        name: ROUTE_NAME_DUPLICATE.CYCLE.DETAIL,
                        component: DuplicateCycleDetail,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':cycleId/item/:itemId/deck',
                        name: ROUTE_NAME_DUPLICATE.CYCLE.DECK,
                        component: DuplicateCycleDeck,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':cycleId/item/:itemId/rank',
                        name: ROUTE_NAME_DUPLICATE.CYCLE.RANK,
                        component: DuplicateCycleRank,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
